<template>
  <div>
    <router-view />
    <dbs-alert />
  </div>
</template>

<script>
  import Alert from './views/dashboard/component/Alert';

  export default {
    name: 'App',
    components: {
      'dbs-alert': Alert,
    },
  };

</script>
